import Vue from 'vue';
import VueI18n from 'vue-i18n';
import hebrew from './types/he';
import english from './types/en';

Vue.use(VueI18n);

const messages={
  'en':english,
  'he':hebrew,
};

const i18n = new VueI18n({
  locale: 'he', // set locale
  fallbackLocale: 'en', // set fallback locale
  messages, // set locale messages
});

export default(i18n);



// WEBPACK FOOTER //
// ./src/lang/i18n.js